import React from 'react';
import css from './BookingSupport.module.css';
import IconCollection from '../IconCollection/IconCollection';
import { FormattedMessage } from 'react-intl';

const BookingSupport = () => {
    const items = [
        {
            icon: <IconCollection name="checkout_lock" />,
            titleId: 'CheckoutPage.secureBookingTitle',
            descriptionId: 'CheckoutPage.secureBookingDescription'
        },
        {
            icon: <IconCollection name="checkout_trust" />,
            titleId: 'CheckoutPage.trustedPaymentsTitle',
            descriptionId: 'CheckoutPage.trustedPaymentsDescription'
        },
        {
            icon: <IconCollection name="checkout_support" />,
            titleId: 'CheckoutPage.realSupportTitle',
            descriptionId: 'CheckoutPage.realSupportDescription'
        }
    ];
    return (
        <div className={css.bookingSupport}>
            {items.map((item, idx) => (
                <div key={idx} className={css.item}>
                    <div className={css.topItem}>
                        {item.icon}
                        <div className={css.title}>
                            <FormattedMessage id={item.titleId} />
                        </div>
                    </div>
                    <p className={css.text}>
                        <FormattedMessage id={item.descriptionId} />
                    </p>
                </div>
            ))}
        </div>
    );
};

export default BookingSupport;